import { createContext } from '@shared/utils/createContext';

type UnlockDialogThemeContextValue = Readonly<{
  pageFontColor?: string;
}>;

const [UnlockDialogThemeProvider, useUnlockDialogThemeContext] = createContext<UnlockDialogThemeContextValue>({
  name: 'UnlockDialogThemeContext',
  strict: true,
});

export { UnlockDialogThemeProvider, useUnlockDialogThemeContext };
export type { UnlockDialogThemeContextValue };
